import {
  GOOGLE_REGISTER,
  GOOGLE_SIGN_IN,
  LOGIN,
  LOGIN_OTP,
  LOGIN_RESEND_OTP,
  GENERATE_QR_CODE,
  LOGIN_WITH_QR,
  REGISTER,
  REGISTER_OTP,
  REGISTER_RESEND_OTP,
  PASSWORD_OTP,
  PASSWORD_OTP_VERIFY,
  PASSWORD_CHANGE
} from '../../constants';
import { api } from '../api';
import {
  LoginOTPResponse,
  LoginRequestBody,
  LoginResponse,
  RegisterOTPResponse,
  RegisterRequestBody,
  RegisterResponse,
  RegisterOTPRequestBody,
  LoginOTPRequestBody,
  GoogleSignInRequestBody,
  GoogleRegisterRequestBody,
  GoogleRegisterResponse,
  GoogleSignInResponse,
  GenerateQrCodeResponse,
  LoginWithQrCodeResponse,
  LoginWithQrCodeRequestBody,
  PasswordOTPResponse,
  PasswordOTPRequestBody,
  PasswordOTPVerifyResponse,
  PasswordOTPVerifyRequestBody,
  PasswordChangeResponse,
  PasswordChangeRequestBody
} from './types';

export const authSlice = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<
      LoginResponse,
      LoginRequestBody & { preventSnackbar?: boolean }
    >({
      // preventSnackbar is read by rtkQueryErrorLogger, not sent.
      query({ preventSnackbar, ...data }) {
        return {
          url: LOGIN,
          method: 'POST',
          body: data
        };
      }
    }),
    googleSignIn: build.mutation<GoogleSignInResponse, GoogleSignInRequestBody>(
      {
        query(data) {
          return {
            url: GOOGLE_SIGN_IN,
            method: 'POST',
            body: data
          };
        }
      }
    ),
    GenerateQrCode: build.mutation<GenerateQrCodeResponse, void>({
      query() {
        return {
          url: GENERATE_QR_CODE,
          method: 'POST',
          body: {}
        };
      }
    }),
    LoginWithQrCode: build.mutation<
      LoginWithQrCodeResponse,
      LoginWithQrCodeRequestBody
    >({
      query(data) {
        return {
          url: LOGIN_WITH_QR,
          method: 'POST',
          body: data
        };
      }
    }),
    googleRegister: build.mutation<
      GoogleRegisterResponse,
      GoogleRegisterRequestBody
    >({
      query(data) {
        return {
          url: GOOGLE_REGISTER,
          method: 'POST',
          body: data
        };
      }
    }),
    loginOTP: build.mutation<LoginOTPResponse, LoginOTPRequestBody>({
      query(data) {
        return {
          url: LOGIN_OTP,
          method: 'POST',
          body: data
        };
      }
    }),
    loginResendOTP: build.mutation<void, void>({
      query() {
        return {
          // POST only: a GET never matched the send handler. An empty
          // service id is the login OTP's scope.
          url: LOGIN_RESEND_OTP,
          method: 'POST',
          body: { service_id: '' }
        };
      }
    }),
    register: build.mutation<RegisterResponse, RegisterRequestBody>({
      query(data) {
        return {
          url: REGISTER,
          method: 'POST',
          body: data
        };
      }
    }),
    registerOTP: build.mutation<RegisterOTPResponse, RegisterOTPRequestBody>({
      query(data) {
        return {
          url: REGISTER_OTP,
          method: 'POST',
          body: data
        };
      }
    }),
    registerResendOTP: build.mutation<void, void>({
      query() {
        return {
          url: REGISTER_RESEND_OTP,
          method: 'GET'
        };
      }
    }),
    passwordChange: build.mutation<
      PasswordChangeResponse,
      PasswordChangeRequestBody
    >({
      query(data) {
        return {
          url: PASSWORD_CHANGE,
          method: 'POST',
          body: data
        };
      }
    }),
    passwordOTP: build.mutation<PasswordOTPResponse, PasswordOTPRequestBody>({
      query(data) {
        return {
          url: PASSWORD_OTP,
          method: 'POST',
          body: data
        };
      }
    }),
    passwordOTPVerify: build.mutation<
      PasswordOTPVerifyResponse,
      PasswordOTPVerifyRequestBody
    >({
      query(data) {
        return {
          url: PASSWORD_OTP_VERIFY,
          method: 'POST',
          body: data
        };
      }
    })
  }),

  overrideExisting: false
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useLoginOTPMutation,
  useGoogleRegisterMutation,
  useGoogleSignInMutation,
  useLoginWithQrCodeMutation,
  useGenerateQrCodeMutation,
  useLoginResendOTPMutation,
  useRegisterOTPMutation,
  useRegisterResendOTPMutation,
  usePasswordOTPMutation,
  usePasswordOTPVerifyMutation,
  usePasswordChangeMutation
} = authSlice;
